import { render, staticRenderFns } from "./DetailEmployee.vue?vue&type=template&id=676c1295&scoped=true&"
import script from "./DetailEmployee.vue?vue&type=script&lang=js&"
export * from "./DetailEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676c1295",
  null
  
)

export default component.exports